export enum ClaimSetType {
  NewSet = 0,
  Revision = 1,
}
